import { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Divider } from '@mui/material';
import { UserContext } from '../../services/User';
import { Pharmacy } from '../../Models';
import { WhatsappNotificationsComponent } from './WhatsappNotifications';
import { DesktopNotificationsComponent } from './DesktopNotifications';

export function Notifications() {
    const { user } = useContext(UserContext);

    return (
        <Grid container spacing={3} direction="column">
            <WhatsappNotificationsComponent user={user as Pharmacy} />

            <Grid xs={12}>
                <Divider sx={{ my: 2 }} />
            </Grid>

            <DesktopNotificationsComponent />
        </Grid>
    );
}
